<template>
<div>

  <!-- View third party modal template -->
  <b-modal
     ref="view-tp"
     hide-footer
     @hide="hideTPModal"
     size="lg"
  >

      <div class="d-block text-center">
        <h4 qid="view-tp-title" v-if="object" class="mb-2">
          {{ $t('maintenance.third_parties.vendors.view_modal_title') }}
        </h4>
      </div>

      <div class="form-container">
        <Avatar :object="object" size="xs"></Avatar>
        <span class="h4">
          {{ object.name }}
        </span>

      </div>

      <div class="form-container">
        <div v-if="object.description && object.description.length > 300">
          <p v-if="showFullDescription" class="text-formatted">
            {{ object.description }}
          </p>
          <p v-if="!showFullDescription" class="text-formatted">
            {{ object.description | truncate(300) }}
          </p>
          <div class="text-center mt-3" @click="showFullDescription=!showFullDescription">
            <span class="cursor-pointer" v-if="!showFullDescription">
              <span class="mr-2">
                {{ $t('system.view_more') }}
              </span>
              <font-awesome-icon icon="chevron-down"/>
            </span>
            <span class="cursor-pointer" v-if="showFullDescription">
              <span class="mr-2">
                {{ $t('object.view_less') }}
              </span>
              <font-awesome-icon icon="chevron-up"/>
            </span>
          </div>
        </div>
        <p v-if="object.description && object.description.length <= 300"
           class="text-formatted"
        >
          {{ object.description }}
        </p>
      </div>

      <div class="form-container">
        <div class="card">
          <div class="card-header">
            <div class="float-left">
              <h5 class="mb-2">
                {{ $t('maintenance.third_parties.address_label') }}
              </h5>
            </div>
          </div>


          <div class="row no-gutters">
            <div class="col-sm-4 card-menu">
              <div class="card-body text-dark">
                <p>{{ $t('administration.clients.create.street_label') }}</p>
                <br>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="card-body">
                <p>{{ object.address }}</p>
                <br>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-4 card-menu">
              <div class="card-body text-dark">
                <p>{{ $t('administration.clients.create.postcode_label') }}</p>
                <br>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="card-body">
                <p>{{ object.postal_code }}</p>
                <br>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-4 card-menu">
              <div class="card-body text-dark">
                <p>{{ $t('administration.clients.create.city_label') }}</p>
                <br>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="card-body">
                <p>{{ object.city }}</p>
                <br>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-4 card-menu">
              <div class="card-body text-dark">
                <p>{{ $t('administration.clients.create.state_label') }}</p>
                <br>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="card-body">
                <p>{{ object.state }}</p>
                <br>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-4 card-menu">
              <div class="card-body text-dark">
                <p>{{ $t('administration.clients.create.country_label') }}</p>
                <br>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="card-body">
                <p>{{ object.country }}</p>
                <br>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div class="col-sm-4 card-menu">
              <div class="card-body text-dark">
                <p class="mt-2">{{ $t('administration.clients.create.cvr_label') }}</p>
                <br>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="card-body">
                <p class="mt-2">{{ object.company_number }}</p>
                <br>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="text-right">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideTPModal"
                  qid="create-rr-cancel-button"
        >
          {{ $t('system.close') }}
        </b-button>

      </div>

  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';


  export default {
    name: 'ThirdPartyViewModal',
    data: function() {
      return {
        error: '',
        showInput: false,
        inputLink: '',
        inputLinkName: '',
        loadingItems: false,
        showArticleDescription: false,
        secondaryDO: [],
        selectedFileObject: {},
        selectedFileIndex: '',
        selectedLinkObject: {},
        selectedLinkIndex: '',
        showFullDescription: false
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      },
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getMedia() {
        return this.object.media
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showTPModal()
        }
      }
    },
    methods: {
      showTPModal() {
        let self = this;

        this.$refs['view-tp'].show()
      },
      hideTPModal() {
        this.error = ''
        this.showFullDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-tp'].hide()
      }
    },
    created () {

    }
  }
</script>
